import { ApolloQueryResult, FetchResult, gql } from '@apollo/client';
import { ClientLogger } from '../client-logger';
import { passwordResetStartMutation, serverInfoQuery, LoginInput, changePasswordMutation, loginMutation } from './verid-api-types';
// import { me_me, me_me_personOrgs, me_me_personOrgs_org } from './api-types-parts';
import { useVeridApi, useMultiAuth } from './hybrid-apollo-client';
import { useRef } from 'react';

const DEBUG = false;

export function useAuthService() {
  const { globalSignOut, passportSignIn } = useMultiAuth();
  const api = useVeridApi();

  const apiFunctions = useRef({
    login: (data: LoginInput) =>
      passportSignIn(data.email, data.password, data.orgId ?? null, data.authConfigId ?? null, data.role ?? null),

    async passwordResetStart(email: string): Promise<FetchResult<passwordResetStartMutation>> {
      const result = await api.mutate<passwordResetStartMutation>({
        mutation: gql`
          mutation passwordResetStart($email: String!) {
            passwordResetStart(email: $email)
          }
        `,
        variables: { email },
        context: { noAuth: true },
      });
      DEBUG &&
        ClientLogger.debug('AuthClient.passwordResetStart', 'response', {
          result,
        });

      return result;
    },

    async passwordResetFinish(token: string, newPassword: string): Promise<FetchResult<loginMutation>> {
      const result = await api.mutate<loginMutation>({
        mutation: gql`
          mutation passwordResetFinish($token: String!, $newPassword: String!) {
            passwordResetFinish(token: $token, newPassword: $newPassword)
          }
        `,
        variables: { token, newPassword },
        context: { noAuth: true },
      });
      DEBUG &&
        ClientLogger.debug('AuthClient.passwordResetFinish', 'response', {
          result,
        });

      return result;
    },

    async changePassword(personOrgId: string, oldPassword: string, newPassword: string) {
      return api.mutate<changePasswordMutation>({
        mutation: gql`
          mutation changePassword($personOrgId: String!, $newPassword: String!, $oldPassword: String!) {
            changePassword(personOrgId: $personOrgId, data: { newPassword: $newPassword, oldPassword: $oldPassword }) {
              id
            }
          }
        `,
        variables: { data: { personOrgId, newPassword, oldPassword } },
      });
    },

    getMe: async () => {
      try {
        return api.refreshMe();
      } catch (err) {
        return null;
      }
    },
    logout: globalSignOut,

    async serverInfo(): Promise<ApolloQueryResult<serverInfoQuery>> {
      DEBUG && ClientLogger.debug('serverInfo', `started`);
      const resp = await api.query<serverInfoQuery>({
        query: gql`
          query serverInfo {
            serverInfo {
              branch
              buildDate
              buildId
              commit
              dbConnectTest
              reactAppAddress
            }
          }
        `,
        variables: {},
        fetchPolicy: 'network-only',
        context: { noAuth: true },
      });
      DEBUG && ClientLogger.debug('serverInfo', 'Response', resp);
      return resp;
    },
  });
  return apiFunctions.current;
}
